var PresentersBase, SharedUtilsHelper, SupportAPIHelper, SupportUtilsHelper;

PresentersBase = require('../../../backbone_base/frontend/presenters/base');

SupportUtilsHelper = require('../../../support/frontend/helpers/utils');

SupportAPIHelper = require('../../../support/frontend/helpers/API');

SharedUtilsHelper = {
  toHtml: (function(_this) {
    return function(template, hash, scope) {
      if ((template != null ? template.render : void 0) != null) {
        return template.render(PresentersBase.toHashWithHelpers(hash, scope));
      }
    };
  })(this),
  redirectToFaq: function() {
    return window.location.href = "" + window.FAQBASEURL;
  },
  redirectToHelpWizard: function() {
    return window.location.href = "" + window.SUPPORTBASEURL;
  },
  scrollTo: function($container) {
    var hash, ref;
    if ($container) {
      hash = {
        scrollTop: (ref = $container.offset()) != null ? ref.top : void 0
      };
      return $('html, body').animate(hash, 1000);
    }
  },
  toggleCallUs: function(id) {
    var experiment;
    addWrapperLinkOverCallUs();
    experiment = $('span.lnk-call-us').attr('id');
    $('span.lnk-call-us').removeAttr('data-bhw-path');
    $('span.lnk-call-us').removeAttr('data-bhw');
    $('span.lnk-call-us').attr("data-bhw", "phone-number-" + experiment + "-" + id);
    return $('span.lnk-call-us').data("bhw", "phone-number-" + experiment + "-" + id);
  },
  addWrapperLinkOverCallUs: function() {
    $('.contact-number').addClass('hide');
    return $('span.lnk-call-us').addClass('lnk');
  },
  propagateEventBeforeReplacingElements: function(cb) {
    setTimeout(cb);
    return true;
  },
  removeSpecificParamFromUrl: function(url, parameter) {
    var hash, hashPresent, i, pars, prefix, queryString, urlBase, urlparts;
    if (url.indexOf('#') > 0) {
      hashPresent = true;
      hash = url.substr(url.indexOf('#') + 1);
    }
    urlparts = url.split("?");
    if (urlparts.length >= 2) {
      urlBase = urlparts.shift();
      queryString = urlparts.join("?");
      prefix = encodeURIComponent(parameter) + "=";
      pars = queryString.split(/[&;]/g);
      i = pars.length;
      while (i-- > 0) {
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }
      url = urlBase + "?" + pars.join("&");
    }
    if (url.indexOf('#') === -1 && hashPresent) {
      url = url + '#' + hash;
    }
    return url;
  },
  abortAjaxRequests: function(requests) {
    _.each(requests, function(req) {
      return req.abort();
    });
    return null;
  },
  startTimer: function(timer) {},
  stopTimer: function(timer) {},
  isIntl: function() {
    var ref;
    return checkIfIsEMEAByCountryCluster((ref = window.country) != null ? ref.cluster : void 0);
  },
  isUS: function() {
    var ref;
    return checkIfIsUSByCountryCluster((ref = window.country) != null ? ref.cluster : void 0);
  },
  isNeedish: function() {
    var ref;
    return checkIfIsNEEDISHByCountryCluster((ref = window.country) != null ? ref.cluster : void 0);
  },
  checkIfIsUSByCountry: function(country) {
    return getCountryCluster(country) === 'US';
  },
  checkIfIsEMEAByCountry: function(country) {
    return getCountryCluster(country) === 'EMEA';
  },
  checkIfIsNEEDISHByCountry: function(country) {
    return getCountryCluster(country) === 'NEEDISH';
  },
  checkIfIsUSByCountryCluster: function(countryCluster) {
    return countryCluster === 'US';
  },
  checkIfIsEMEAByCountryCluster: function(countryCluster) {
    return countryCluster === 'EMEA';
  },
  checkIfIsNEEDISHByCountryCluster: function(countryCluster) {
    return countryCluster === 'NEEDISH';
  },
  getCountryCluster: function(country) {
    if (country != null) {
      country = country.toUpperCase();
    }
    if (country === 'US' || country === 'IN') {
      return country;
    }
    if (country === 'PH' || country === 'TH') {
      return 'ASIA';
    }
    if (country === 'CL' || country === 'CO' || country === 'MX' || country === 'PA' || country === 'PE' || country === 'PR' || country === 'UY') {
      return 'NEEDISH';
    }
    return 'EMEA';
  },
  getCallUsMsg: function() {
    var customPhoneNumber;
    customPhoneNumber = getCustomPhoneNumber();
    if (customPhoneNumber != null) {
      return I18n.translate('js.modules.shared.call_us_message_with_custom_phone_number', {
        custom_phone_number: customPhoneNumber
      });
    } else {
      return I18n.translate('js.modules.shared.call_us_message');
    }
  },
  getCustomPhoneNumber: function() {
    var dealType, ref;
    dealType = (ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0;
    if ((typeof phoneNumbers !== "undefined" && phoneNumbers !== null ? phoneNumbers[dealType] : void 0) != null) {
      return phoneNumbers[dealType].custom;
    }
  },
  evaluate: function(key) {
    return (key != null) && (key === true || key === "true");
  },
  isCMSEnabled: function() {
    return (typeof experiments !== "undefined" && experiments !== null ? experiments.shouldDisplayCMSContentForUS : void 0) || !isUS();
  },
  showDOMElems: function(DOMElems) {
    addShowClass(DOMElems);
    return removeHideClass(DOMElems);
  },
  showDOMElemsInline: function(DOMElems) {
    removeHideClass(DOMElems);
    return addInlineClass(DOMElems);
  },
  hideDOMElems: function(DOMElems) {
    removeShowClass(DOMElems);
    return addHideClass(DOMElems);
  },
  addShowClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'show');
  },
  addInlineClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'display-inline');
  },
  removeDOMElemsInline: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'display-inline');
  },
  removeHideClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'hide');
  },
  removeShowClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'show');
  },
  addHideClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'hide');
  },
  addBtnPrimaryClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'btn-primary');
  },
  addBtnSecondaryClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'btn-invert');
  },
  addPreferredContactClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'preferred-contact-channel');
  },
  removeBtnPrimaryClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'btn-primary');
  },
  removeBtnSecondaryClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'btn-invert');
  },
  removePreferredContactClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'preferred-contact-channel');
  },
  addBloodHoundTagToDOMElems: function(DOMElems, tagName) {
    return manipulateDOMElems(DOMElems, window.addBloodHoundTagToDOMElem, tagName);
  },
  addClassToDOMElems: function(DOMElems, className) {
    return manipulateDOMElems(DOMElems, window.addClassToDOMElem, className);
  },
  removeClassFromDOMElems: function(DOMElems, className) {
    return manipulateDOMElems(DOMElems, window.removeClassFromDOMElem, className);
  },
  manipulateDOMElems: function(DOMElems, manipulateDOMElem, CSSSelector) {
    DOMElems = getInArrayFormat(DOMElems);
    return _.each(DOMElems, (function(_this) {
      return function(DOMElem, index) {
        return manipulateDOMElem(DOMElem, CSSSelector);
      };
    })(this));
  },
  addClassToDOMElem: function(DOMElem, className) {
    return DOMElem.addClass(className);
  },
  addBloodHoundTagToDOMElem: function(DOMElem, tagName) {
    DOMElem.removeAttr('data-bhw-path');
    DOMElem.removeAttr('data-bhw');
    DOMElem.attr("data-bhw", tagName);
    return DOMElem.data("bhw", tagName);
  },
  removeClassFromDOMElem: function(DOMElem, className) {
    return DOMElem.removeClass(className);
  },
  getInArrayFormat: function(elements) {
    if (_.isArray(elements)) {
      return elements;
    } else {
      return [elements];
    }
  },
  createTicket: (function(_this) {
    return function(data, successCb, errorCb, loadElem, loadingElemHeight) {
      data.is_costco_deal = SupportUtilsHelper.isCostcoDeal();
      return propagateEventBeforeReplacingElements(function() {
        var method, ref, tHubData, url;
        SupportUtilsHelper.showLoading(loadElem, loadingElemHeight);
        url = window.SUPPORTBASEURL + "/ticket/create";
        method = "POST";
        tHubData = {
          ticketParams: data,
          user: (ref = window.currentUser) != null ? ref.id : void 0
        };
        TrackingHub.add('ticket-create-params', {
          params: tHubData
        });
        return SupportAPIHelper.call(url, method, data, successCb, errorCb, false);
      });
    };
  })(this),
  isCostcoRelatedFAQ: function() {
    var currentArticleId, currentBreadcrumpsId;
    currentBreadcrumpsId = $('.breadcrumps_text').attr('breadcrumps_id');
    if (isCostcoSpecificTopicId(currentBreadcrumpsId)) {
      return true;
    }
    currentArticleId = $('.link').attr('inbenta_contentid');
    if (isCostcoSpecificArticle(currentArticleId)) {
      return true;
    }
    return false;
  },
  isCostcoSpecificTopicId: function(currentTopicId) {
    var costcoTopicIds, ref, ref1;
    costcoTopicIds = (ref = window.costcoConfig) != null ? (ref1 = ref.faq) != null ? ref1.breadcrumps_ids : void 0 : void 0;
    return (currentTopicId != null) && (costcoTopicIds != null) && costcoTopicIds.includes(currentTopicId);
  },
  isCostcoSpecificArticle: function(currentArticleId) {
    var costcoArticleIds, ref, ref1;
    costcoArticleIds = (ref = window.costcoConfig) != null ? (ref1 = ref.faq) != null ? ref1.article_ids : void 0 : void 0;
    return (currentArticleId != null) && (costcoArticleIds != null) && costcoArticleIds.includes(currentArticleId);
  }
};

module.exports = SharedUtilsHelper;

//# sourceMappingURL=data:application/json;base64,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
